import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * Shown when the signed-in user's role does not cover a screen. Says who to ask
 * rather than just refusing — in a plumbing business the person who can fix it
 * is sitting in the same office.
 */
export function Forbidden() {
  const { t } = useTranslation();

  return (
    <section className="space-y-4" data-testid="forbidden">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{t('forbidden.title')}</h1>
        <p className="text-sm text-[var(--color-muted-foreground)]">
          {t('forbidden.description')}
        </p>
      </div>
      <Button asChild variant="outline" size="sm">
        <Link to="/">{t('common.backToDashboard')}</Link>
      </Button>
    </section>
  );
}
